<template>
  <div class="main_right">
    <div class="page_info">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem>用户管理</BreadcrumbItem>
      </Breadcrumb>
      <div class="searchBox">
        <div>
          <Button type="primary" icon="plus" @click="toAddUser" v-if="authList.indexOf('003001') !== -1">添加</Button>
          <Button type="error" icon="minus" @click="batchDelete" v-if="authList.indexOf('003005') !== -1">删除</Button>
        </div>
        <Input v-model="reqbody.searchKey" icon="ios-search" placeholder="用户名/所属公司" style="width: 200px" @on-click="search" @keyup.13.native="search"/>
      </div>

      <Table border height="520" ref="user_table" :columns="columns" :data="tableData" @on-select-all="setAllBatch" @on-select="setBatch" @on-select-cancel="delBatch"></Table>
      <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
    </div>

    <Modal
      v-model="openSimple"
      title="提示"
      @on-ok="sureDelete"
      @on-cancel="cancelDelete">
      <p>是否确认删除用户？</p>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import TopOpe from '../top-ope/top-ope'
import {errorHandler} from '../../util/errorHandler'
import {nSuccess, nError} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  components: {TopOpe},
  name: 'account-management',
  data () {
    return {
      authList: '',
      openSimple: false,
      reqbody: {
        searchKey: '',
        pageSize: 10,
        pageNo: 1
      },
      columns: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '用户名',
        key: 'userName',
        align: 'center'
      }, {
        title: '所属公司',
        key: 'company',
        align: 'center'
      }, {
        title: '关联角色',
        key: 'roleName',
        align: 'center'
      }, {
        title: '操作',
        key: 'operation',
        align: 'center',
        render: (h, params) => {
          if (params.row.authStatusM && !params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifyUser(params.row.id)
                  }
                }
              }, '修改')
            ])
          } else if (!params.row.authStatusM && params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteUser(params.row.id)
                  }
                }
              }, '删除')
            ])
          } else if (params.row.authStatusM && params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifyUser(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteUser(params.row.id)
                  }
                }
              }, '删除')
            ])
          }
        }
      }],
      tableData: [],
      total: 0,
      deleteDevId: {},
      batchId: {
        ids: ''
      }
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getUserPage()
  },
  methods: {
    toAddUser () {
      this.$router.push({
        path: '/add_account'
      })
    },
    getUserPage () {
      this.$axios.post(`${httpUrl.url}/manage/user/getPage`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (this.authList.indexOf('003004') !== -1) {
              data.list.map(v => {
                v.authStatusM = true
              })
            } else {
              data.list.map(v => {
                v.authStatusM = false
              })
            }
            if (this.authList.indexOf('003005') !== -1) {
              data.list.map(v => {
                v.authStatusD = true
              })
            } else {
              data.list.map(v => {
                v.authStatusD = false
              })
            }
            this.tableData = data.list
            this.total = data.total
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    setAllBatch (selection) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    setBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    delBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    batchDelete () {
      if (!this.batchId.ids) {
        nError('请先选择设备')
        return false
      }
      this.deleteUser(this.batchId.ids)
    },
    modifyUser (id) {
      this.$router.push({
        path: '/modify_account/' + id
      })
    },
    deleteUser (id) {
      this.openSimple = true
      this.deleteDevId.ids = id.toString()
    },
    sureDelete () {
      this.$axios.post(`${httpUrl.url}/manage/user/deleteByIds`, this.deleteDevId)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.openSimple = false
            this.reqbody.pageNo = 1
            this.getUserPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    cancelDelete () {
      this.openSimple = false
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getUserPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getUserPage()
    },
    search () {
      this.reqbody.pageNo = 1
      this.getUserPage()
    }
  }
}
</script>

<style scoped>
  .main_right {
    min-width: 780px;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }
  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/account-management.vue